import { prevDay } from './game';

const K = {
  streak: 'geodle:streak',
  lastWin: 'geodle:lastWin',
  state: (mode: string, day: string) => `geodle:state:${mode}:${day}`,
};

function read<T>(key: string, fallback: T): T {
  try {
    const v = localStorage.getItem(key);
    return v ? (JSON.parse(v) as T) : fallback;
  } catch {
    return fallback;
  }
}
function write(key: string, value: unknown): void {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {
    /* ignore */
  }
}

export function getStreak(): number {
  return Number(localStorage.getItem(K.streak) || 0);
}

/** 答对当日记一次连胜:昨天也赢则 +1,否则重置为 1;重复调用幂等 */
export function recordWin(dayKey: string): number {
  const last = localStorage.getItem(K.lastWin);
  if (last === dayKey) return getStreak();
  const streak = last === prevDay(dayKey) ? getStreak() + 1 : 1;
  localStorage.setItem(K.streak, String(streak));
  localStorage.setItem(K.lastWin, dayKey);
  return streak;
}

export interface ModeState {
  guesses: string[]; // cca3 列表
  status: 'playing' | 'won' | 'lost';
}

export function getModeState(mode: string, day: string): ModeState {
  return read<ModeState>(K.state(mode, day), { guesses: [], status: 'playing' });
}
export function setModeState(mode: string, day: string, state: ModeState): void {
  write(K.state(mode, day), state);
}
